/** Left drawer width: fraction of window width, capped for large screens */
export const ACCOUNT_ADMIN_DRAWER_WIDTH_FRACTION = 0.78

export const ACCOUNT_ADMIN_DRAWER_MAX_WIDTH = 360

export const ACCOUNT_ADMIN_DRAWER_SLIDE_MS = 250

/**
 * Web: only apply drawer “push” (margin + narrowed width) when at least this many px remain
 * for the main column. Below this, the drawer overlays full-width content — otherwise mobile
 * gets a ~20–90px text column and unusable wrapping.
 */
export const ACCOUNT_ADMIN_WEB_DRAWER_PUSH_MIN_REMAINING_WIDTH_PX = 300

/**
 * Web (site surface): above this viewport width the persistent sidebar replaces the hamburger drawer.
 */
export const ACCOUNT_ADMIN_SIDEBAR_BREAKPOINT_PX = 960
